import { render, staticRenderFns } from "./RiskLimitModal.vue?vue&type=template&id=88853e80&scoped=true"
import script from "./RiskLimitModal.vue?vue&type=script&lang=js"
export * from "./RiskLimitModal.vue?vue&type=script&lang=js"
import style0 from "./RiskLimitModal.vue?vue&type=style&index=0&id=88853e80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88853e80",
  null
  
)

export default component.exports